module.exports = __webpack_public_path__ + "static/news.dc5f96f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/covers/news.jpg
// module id = 159
// module chunks = 21733507128203 72776394686286